import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export const phoneValidationHelper = (val: string): boolean => {
    try{
    const phoneNumber = parsePhoneNumber(val);
    const countryCode = phoneNumber.country;
    const isPhoneValid = isValidPhoneNumber(val, countryCode);
    return isPhoneValid;
    } catch(e) {
        console.log(e);
        return false;
    }
}

export const emailValidationHelper = (val: string): boolean => {
    if(val.length < 4) {
        return false;
    }
    const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(val);
}